/** Funnel mock — sales_channel mode. */

export const FUNNEL_MOCK_SALES_CHANNEL = {
  mode: 'sales_channel',
  dataSourceLabel: 'VM Platform · CMP',
  confidence: {
    tone: 'success',
    title: 'High confidence — CMP channel flags only.',
  },
  kpis: [
    {
      id: 'conversion',
      label: 'Online ticket share',
      value: '38%',
      detail: '3,914 of 10,300 eligible',
    },
    {
      id: 'dropoff',
      label: 'Biggest gap',
      value: 'On-site still leads',
      detail: '6,386 · 62%',
    },
    {
      id: 'pending',
      label: 'Pending tickets',
      value: '2,100',
      detail: 'Excluded from channel %',
    },
    {
      id: 'online_share',
      label: 'Online share',
      value: '38% · +3 pt',
      detail: 'vs prior season 35%',
    },
  ],
  chart: {
    title: 'Sales channel mix',
    stages: [
      {
        id: 'ticket_purchased',
        index: '01',
        label: 'Ticket purchased',
        total: 12400,
        converted: 10300,
        dropped: 0,
        pending: 2100,
        pendingLabel: '2,100 pending',
      },
      {
        id: 'online',
        index: '02',
        label: 'Bought online',
        total: 10300,
        converted: 3914,
        dropped: 6386,
        pending: 0,
        conversionLabel: '38%',
        droppedLabel: '−6,386 on-site',
      },
      {
        id: 'onsite',
        index: '03',
        label: 'Bought on-site / POS',
        total: 10300,
        converted: 6386,
        dropped: 3914,
        pending: 0,
        conversionLabel: '62%',
        droppedLabel: '−3,914 online',
      },
    ],
  },
  pending: null,
  insight: {
    eyebrow: 'Biggest gap',
    title: 'On-site still takes 6 of 10 tickets — and costs more per sale.',
    action: 'Run a timed online-only discount 10 days before the next midweek fixture.',
  },
  stageInsights: {
    ticket_purchased: {
      eyebrow: 'Baseline',
      title: 'All channels · pending held out of share %.',
      action: 'Compare midweek vs weekend online conversion.',
    },
    online: {
      eyebrow: 'Online',
      title: '38% of eligible tickets bought online — rising slowly.',
      action: 'Push a timed online-only window before midweek fixtures.',
    },
    onsite: {
      eyebrow: 'Biggest gap',
      title: 'On-site still takes 6 of 10 tickets — and costs more per sale.',
      action: 'Run a timed online-only discount 10 days before the next midweek fixture.',
    },
  },
  steps: [
    {
      id: 'ticket_purchased',
      step: '01 Ticket purchased',
      entered: '12,400',
      converted: '10,300 eligible',
      dropOff: '—',
      medianTime: '—',
    },
    {
      id: 'online',
      step: '02 Online',
      entered: '10,300',
      converted: '3,914 (38%)',
      dropOff: '—',
      medianTime: '—',
    },
    {
      id: 'onsite',
      step: '03 On-site / POS',
      entered: '10,300',
      converted: '6,386 (62%)',
      dropOff: '—',
      medianTime: '—',
    },
  ],
};
